import React, {useState, useEffect} from 'react';
import PropTypes from "prop-types";
import {DokaModal, toURL} from './react-doka';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import {submitProviderLogo} from "./DataFunctions/ProviderFns";
import {ImagePicker} from 'react-file-picker'
import {checkError} from "root/DataFunctions/BaseDataFns";
import './DemoModal.scss';
import {ImageType} from "root/DataFunctions/Constants";
import {getDocumentUrl} from "root/DataFunctions/CommonDataFns";
// import bootbox from "bootbox";

const NewImageButtonIcon = (props) => {
    return (
        <div>
            {/* All the image picker buttons have the exact position on the page */}
            {/* only the button of the first modal with an undefined value in the multipleImageData array is displayed*/}
            {(props.imageNo < 4) && <span
                className={props.imageIndex === props.imagePickerIndexToTrigger ?
                            'picker_add picker_add-show'
                            :
                            'picker_add'
                            }

                onClick={props.onClick}
            >
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-right">
                            Add image
                        </Tooltip>
                    }
                >
                    <i className='icon-add'/>
                </OverlayTrigger>
            </span>}
        </div>
    )
}

const NewImageButton = (props) =>
{
    const style = {
        borderRadius: '5px',
        padding: '4px 8px 4px 8px',
        fontSize: '1.2rem',
        lineHeight: '1.2rem',
        backgroundColor: '#56974d',
        color: 'white'
    }
    return (
        <>
            {/* check if we are working with multiple images or single image upload */}
            {props.onMultipleImageChange &&
                <NewImageButtonIcon
                    onClick={props.onClick}
                    imageIndex={props.imageIndex}
                    imageNo={props.imageNo}
                    imagePickerIndexToTrigger={props.imagePickerIndexToTrigger}
                />
            }

            {!props.imageDataAlias && !props.onMultipleImageChange && <span className='picker_add picker_add-show' onClick={props.onClick}>
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-right">
                            Add image
                        </Tooltip>
                    }
                >
                    <i className='icon-add'/>
                </OverlayTrigger>
            </span>}
            
        </>
    )
}

const SaveChangesButton = (props) =>
{
    const style = {
        borderRadius: '5px',
        padding: '4px 8px 4px 8px',
        fontSize: '1.2rem',
        lineHeight: '1.2rem',
        backgroundColor: '#0278c1',
        color: 'white'
    }
    return <button style={style} onClick={props.onClick}>{props.children}</button>
}

const DemoModal = (props) => {
    const imageIndex = props.imageIndex
    const logoPath = (document_id) =>
    {
        const path = getDocumentUrl(document_id);
        return path;
    }

    const [enabled, setEnabled] = useState(false);
    const [result, setResult] = useState(null);
    const [newImg, setNewImg] = useState(null);
    const [changesPending, setChangesPending] = useState(false);

    const getPlaceholderImg = () => {
        let defaultSrcPath = '';

        switch(props.image_type){
            case ImageType.IMAGE_RESOURCE:
                defaultSrcPath = '/images/default_resource.png';
                break;
            case ImageType.IMAGE_PERSON:
                defaultSrcPath = '/images/defaultPerson.jpg';
                break;
            case ImageType.IMAGE_FAMILY:
                defaultSrcPath = '/images/defaultFamily.jpg';
                break;
            default:
                defaultSrcPath = '/images/defaultPerson.jpg';
        }
        return defaultSrcPath;
    }

    const getDefaultSrcPath = () => {
        let defaultSrcPath = '';

        if (props.image_id === null || props.image_id === undefined)
        {
            defaultSrcPath = getPlaceholderImg();
        }
        return defaultSrcPath;
    }

    const docPath = props.image_id === null || props.image_id === undefined?getDefaultSrcPath():logoPath(props.image_id);

    const [src, setSrc] = useState(docPath);

    useEffect(() =>
    {
        if (props.image_id !== null && props.image_id !== undefined)
        {
            let docPath = logoPath(props.image_id);
            setSrc(docPath);
        }
    }, [props.image_id]);

    const handleToggle = () =>
    {
        setEnabled(enabled => {
            return !enabled;
        });
    }

    const saveComplete = (data) =>
    {
        if (checkError(data))
        {
            setChangesPending(false);
        }
    }

    const handleSave = () =>
    {
        if (result)
        {
            const reader = new window.FileReader();
            reader.readAsDataURL(result);

            reader.onloadend = () =>
            {
                const base64data = reader.result;

                const data = {data: base64data};

                submitProviderLogo(props.provider_id, data, saveComplete);
            }
        }
    }

    const handleDokaConfirm = (output) =>
    {
        props.onImageChange ( output.file ) ;
        props.multipleImageData && props.onMultipleImageChange ( output.file, props.imageIndex ) ;

        const i = output.data.crop;
        setEnabled(false);
        setResult(output.file);
        setChangesPending(true);
    }

    const handleDokaCancel = () =>
    {
        setEnabled(false);
    }

    const imgStyle = {
        borderRadius: '10px',
        boxShadow: '3px 4px 6px -1px #000'
    }

    const multipleImgStyle = {
        borderRadius: '10px',
        boxShadow: '2px 2px 4px -4px #000'
    }

    const picker = () =>
    {
        return (
            <ImagePicker
                extensions={['jpg', 'jpeg', 'png']}
                maxSize={10}
                dims={{minWidth: 20, maxWidth: 8000, minHeight: 20, maxHeight: 8000}}
                onChange={onNewImageSelected}
                onError={onImageSelectError} >
                <NewImageButton 
                    imageIndex={imageIndex} 
                    onClick={handleToggle}
                    imagePickerIndexToTrigger={props.imagePickerIndexToTrigger}
                    imageNo={props.imageNo}
                    onMultipleImageChange={props.onMultipleImageChange}
                    newImageData={props.newImageData}
                    imageDataAlias={props.imageDataAlias}
                />
            </ImagePicker>
        )
    }

    const placeHolder = () =>
    {

        const localSrc = result ? toURL(result) : src ;
        return (
            <div className="profile-img-container">
                <div className='profile-img-container-inner'>
                    <img
                        style={props.multipleImageData ? multipleImgStyle : imgStyle}
                        width={props.dimensions}
                        height={props.dimensions}
                        src={localSrc}
                        alt=""
                    />
                    <span className='profile-img-edit-wrap'>
                        <i onClick={handleToggle} className='icon-edit' style={{
                            position: 'absolute',
                            top: '19px',
                            left: props.dimensions - 25,
                            cursor: 'pointer',
                            color: 'var(--s360-icon-blue)'
                        }}/>
                    </span>
                </div>
                <div className="profile-img-picker">
                    {picker()}
                </div>
            </div>
            )
    }

    const onNewImageSelected = (base64) =>
    {
        setResult(null);
        setChangesPending(true);
        setNewImg(base64);
        setEnabled(true);
    }

    const onImageSelectError = (errMsg) =>
    {
        console.log(errMsg);

        bootbox.alert({
            size: "small",
            message: errMsg,
            callback: (result =>
            {
                //
            })
        })
    }

    const saveButton = () =>
    {
        if (changesPending)
        {
            return (
                <div className='row'>
                    <div className='col-md-12'>
                        <SaveChangesButton onClick={handleSave}>Save Changes</SaveChangesButton>
                    </div>
                </div>
            )
        }
    }

    return (
        <div>
            {enabled && <DokaModal
                utils={['crop', 'filter', 'color', 'markup']}
                outputData={true}
                src={result ? result : newImg ? newImg : src}
                onConfirm={handleDokaConfirm}
                onCancel={handleDokaCancel}
                outputHeight={960}
                outputQuality={90}

                cropAspectRatioOptions={[
                    {
                        label: 'Portrait',
                        value: 1.25
                    },
                    {
                        label: 'Square',
                        value: 1
                    },
                    {
                        label: 'Landscape',
                        value: 0.75
                    }]}
                crop={
                    {
                        aspectRatio: 1
                    }}/>}

            {placeHolder()}

        </div>);
}


DemoModal.defaultProps = {};

export default DemoModal;

DemoModal.propTypes = {
    image_id: PropTypes.string,
    dimensions: PropTypes.number,
    onImageChange: PropTypes.func
};
